import MinBenchWeightInput from './MinBenchWeightInput';

export default MinBenchWeightInput;
